import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "accordion__wrapper" }
const _hoisted_2 = { class: "accordion" }
const _hoisted_3 = { class: "accordion__content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "accordion__header" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Гармошка")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Accordion = _resolveComponent("Accordion")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_Accordion, {
          currentWords: _ctx.currentWords,
          isVolume: _ctx.isVolume
        }, null, 8, ["currentWords", "isVolume"])
      ])
    ])
  ]))
}